export const getDisplayCompanyName = (companyName, fallback = "CRM") => {
  const name = (companyName || "").trim();

  if (!name) {
    return fallback;
  }

  if (name.toLowerCase().includes("kit19")) {
    return "SSO";
  }

  return name;
};
